<template>
  <div class="record_container">
    <div v-for="(item, index) in questions" :key="index">
      <!-- v-if="data['all_online'] == 0 && item.key == 'call_phone'" -->
      <div v-if="item.key != 'call_phone'" class="record_row">
        <div>
          <span v-if="index + 1 <= 3"> {{ index + 1 }}.</span>
          <span v-if="data['all_online'] == null && index + 1 > 3">
            {{ index }}.</span
          >
          <span v-if="data['all_online'] == 0 && index + 1 > 3">
            {{ index + 1 }}.</span
          >
          <span v-if="index + 1 > 3 && data['all_online'] == 1">
            {{ index }}.</span
          >
          {{ item.title }}
        </div>

        <el-radio-group class="record_row_radio" v-model="data[item.key]">
          <el-radio
            v-for="(answer, i) in item.answers"
            :key="i"
            :label="i"
            :value="i"
            >{{ answer }}</el-radio
          >
        </el-radio-group>
      </div>
      <div
        v-if="data['all_online'] == 0 && item.key == 'call_phone'"
        class="record_row"
      >
        <div>{{ index + 1 }}. {{ item.title }}</div>
        <el-radio-group class="record_row_radio" v-model="data[item.key]">
          <el-radio
            v-for="(answer, i) in item.answers"
            :key="i"
            :label="i"
            :value="i"
            >{{ answer }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <div class="record_btn_group">
      <CustomButton
        class="record_btn"
        size="small"
        @click="submit"
        v-if="!this.data.id"
        >提交</CustomButton
      >
      <CustomButton
        class="record_btn"
        size="small"
        @click="this.$router.back()"
        v-else
        >返回</CustomButton
      >
    </div>
  </div>
</template>

<script>
import CustomButton from "@/components/unit/CustomButton";
export default {
  name: "executionRecord",
  components: {
    CustomButton,
  },
  data() {
    return {
      data: {
        // shared_field_homepage: null,
        // open_timer: null,
        // all_online: null,
        // call_phone: null,
        // check_account: null,
        // opening_speech: null,
        // assistance_speak: null,
      },
      questions: [
        {
          title: "会前0.5小时开启直播间后，直播间是否已共享串场首页?",
          answers: ["未完成", "已完成"],
          key: "shared_field_homepage",
        },
        {
          title: "会议计时器是否已打开，放置幻灯左下角?",
          answers: ["未完成", "已完成"],
          key: "open_timer",
        },
        {
          title: "距离会议开始5分钟，所有专家是否都已上线?",
          answers: ["还有专家未上线", "专家都已上线"],
          key: "all_online",
        },
        {
          title: "是否电话联系医助提醒专家上线?",
          answers: ["未完成", "已完成"],
          key: "call_phone",
        },
        {
          title: "专家是否通过[@百老荟] 账号进入会议?",
          answers: ["无", "有"],
          key: "check_account",
        },
        {
          title: "是否进行开场发言?",
          answers: ["未完成", "已完成"],
          key: "opening_speech",
        },
        {
          title: "是否有医助在会中发言?",
          answers: ["否", "是"],
          key: "assistance_speak",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let url = this.$tools.getURL(this.$urls.live.executeLog, {
        post_id: this.$route.query.id,
      });
      this.$axios
        .get(url)
        .then((res) => {
          if (res.data.id) {
            this.data = res.data;
          }
        })
        .catch((err) => {});
    },
    checkData() {
      let data = {
        shared_field_homepage: null,
        open_timer: null,
        all_online: null,
        call_phone: null,
        check_account: null,
        opening_speech: null,
      };
      for (const key in data) {
        switch (key) {
          case "shared_field_homepage":
          case "open_timer":
          case "all_online":
          case "check_account":
          case "opening_speech":
          case "assistance_speak":
            if (this.data?.[key] == null)
              return this.$tips.error({ text: `请完善所有选项` });
            break;
          case "call_phone":
            if (this.data?.["all_online"] === 0 && this.data?.[key] == null)
              return this.$tips.error({ text: `请完善所有选项` });
        }
      }
      return true;
    },
    submit() {
      if (!this.checkData()) return;
      let currLoading = this.$tips.loading();

      this.$axios
        .post(this.$urls.live.executeLog, {
          ...this.data,
          post_id: this.$route.query.id,
        })
        .then(() => {
          currLoading.close();
          this.$router.back();
        })
        .catch(() => {
          currLoading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.record_container {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.record_row {
  line-height: 1.5;
  padding: 1rem;
  padding-bottom: 0;
}
.record_row_radio {
  padding-left: 2rem;
}
.record_btn_group {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.record_btn {
  width: 50%;
}
</style>